export const operationalEvidencePhotoPurposeAllowlist = [
    'inspection-evidence',
    'tbm-evidence',
    'work-control-evidence',
    'feedback-evidence',
    'incident-evidence',
    'evacuation-drill-evidence',
    'facility-psm-remediation',
];
export function purposeAllowsOperationalEvidencePhoto(purpose) {
    return operationalEvidencePhotoPurposeAllowlist.includes(purpose);
}
export function purposeAllowsEducationEvidencePhoto(purpose) {
    return purpose === 'legal-obligation-evidence';
}
const commonVariants = (format) => [
    { kind: 'thumbnail', maxLongEdge: 360, format, quality: 0.7 },
    { kind: 'preview', maxLongEdge: 1280, format, quality: 0.78 },
    { kind: 'evidence', maxLongEdge: 2048, format, quality: 0.84 },
];
export function policyForEvidenceClass(evidenceClass, options = {}) {
    const compatibleFormat = options.webpSupported === false ? 'image/jpeg' : 'image/webp';
    const preserveOriginal = [
        'serious_risk',
        'incident',
        'legal_evidence',
        'approval_locked',
    ].includes(evidenceClass);
    const inspectionVariants = [
        {
            kind: 'thumbnail',
            maxLongEdge: 480,
            exactWidth: 480,
            exactHeight: 360,
            format: 'image/webp',
            quality: 0.82,
            minimumQuality: 0.58,
            maxBytes: 256 * 1024,
        },
        {
            kind: 'evidence',
            maxLongEdge: 1600,
            exactWidth: 1600,
            exactHeight: 1200,
            format: 'image/webp',
            quality: 0.82,
            minimumQuality: 0.58,
            maxBytes: 2 * 1024 * 1024,
        },
    ];
    return {
        evidenceClass,
        preserveOriginal,
        immutableAfterCommit: preserveOriginal,
        legalHoldEligible: preserveOriginal,
        variants: options.profile === 'operational-evidence-photo' ||
            options.profile === 'education-evidence-photo'
            ? inspectionVariants
            : commonVariants(compatibleFormat),
    };
}
export function decideOriginalPreservation(evidenceClass, flags = {}) {
    if (flags.legalHold) {
        return {
            uploadOriginal: true,
            reason: 'legal_hold',
            mayDiscardLocalSourceAfterVerifiedUpload: false,
        };
    }
    if (flags.approvalCommitted || evidenceClass === 'approval_locked') {
        return {
            uploadOriginal: true,
            reason: 'approval_immutable',
            mayDiscardLocalSourceAfterVerifiedUpload: false,
        };
    }
    if (flags.explicitPreserve) {
        return {
            uploadOriginal: true,
            reason: 'explicit_preservation',
            mayDiscardLocalSourceAfterVerifiedUpload: false,
        };
    }
    const policy = policyForEvidenceClass(evidenceClass);
    return policy.preserveOriginal
        ? {
            uploadOriginal: true,
            reason: `evidence_class:${evidenceClass}`,
            mayDiscardLocalSourceAfterVerifiedUpload: false,
        }
        : {
            uploadOriginal: false,
            reason: 'optimized_derivatives_sufficient',
            mayDiscardLocalSourceAfterVerifiedUpload: true,
        };
}
/** AVIF is delivery-only until mobile Safari encode/decode coverage is proven by telemetry. */
export function selectDeliveryFormat(capabilities) {
    if (capabilities.avif)
        return 'image/avif';
    if (capabilities.webp)
        return 'image/webp';
    return 'image/jpeg';
}
